<label class="wrapper" [ngClass]="{'disabled': disabled()}">
  <ng-content select="[prelabel]"></ng-content>
  <input type="checkbox"
          style="--checkbox-size: {{checkboxSize() ?? '1.5rem'}}"
          (change)="onChange()"
          [disabled]="disabled()"
          [checked]="checked" />
  <span><ng-content></ng-content></span>
</label>
